import { ShoppingBag } from 'lucide-react';

/** Quadro neutro para produtos cuja loja não enviou foto real. Nunca inventa imagem. */
export function NoPhoto({ store, title, large }: { store?: string; title?: string; large?: boolean }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-1 bg-muted/40 p-2 text-center" aria-label="Foto não disponível">
      <ShoppingBag className={large ? 'h-12 w-12 text-brand-blue' : 'h-7 w-7 text-brand-blue'} aria-hidden="true" />
      {store && <span className={`font-semibold text-foreground ${large ? 'text-base' : 'text-[11px]'}`}>{store}</span>}
      {title && <span className={`line-clamp-2 text-muted-foreground ${large ? 'text-sm' : 'text-[10px]'}`}>{title}</span>}
      <span className={`text-muted-foreground ${large ? 'text-xs' : 'text-[9px]'}`}>Foto não enviada pela loja</span>
    </div>
  );
}
